
import { Vue } from "vue-class-component";

export default class SearchOutlineFooter extends Vue {}
